<template>
  <section
    id="services"
    class="services"
  >
    <div class="container">
      <SectionHead
        :icon="data.services.icon"
        :title="data.services.title"
      />

      <div
        class="services__grid"
        :style="{ '--rows': Math.ceil(data.services.items.length / 2) }"
      >
        <article
          v-for="(item, i) in data.services.items"
          :key="i"
          class="service-item"
        >
          <span class="service-item__icon">
            <img
              :src="item.icon"
              :alt="item.title"
            >
          </span>
          <span class="service-item__divider" />
          <div class="service-item__text">
            <h3>{{ item.title }}</h3>
            <p v-if="item.text">{{ item.text }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHead from '@/components/SectionHead.vue'

export default {
  name: 'ServicesSection',
  components: { SectionHead },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.services {
  background: $white;
  padding: 64px 0 72px;
}

.services__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  // remplissage colonne par colonne (maquette) : 1re moitié à gauche, 2de à droite
  grid-template-rows: repeat(var(--rows), auto);
  grid-auto-flow: column;
  gap: 34px clamp(40px, 6vw, 90px);
  margin-top: 44px;
}

.service-item {
  display: flex;
  align-items: center;
  gap: 22px;

  &__icon {
    flex: 0 0 auto;
    width: 54px;
    display: flex;
    justify-content: center;

    img {
      width: 46px;
      height: 46px;
      object-fit: contain;
      // pictos noirs -> vert charte ($green #85BE57)
      filter: brightness(0) saturate(100%) invert(71%) sepia(21%) saturate(1023%) hue-rotate(50deg) brightness(97%) contrast(84%);
    }
  }

  // séparateur vertical en dégradé vert -> bleu (retour client)
  &__divider {
    flex: 0 0 auto;
    width: 2px;
    align-self: stretch;
    min-height: 56px;
    background: linear-gradient(180deg, $green, $blue);
    border-radius: 2px;
  }

  &__text {
    h3 {
      font-size: 15px;
      font-weight: 700;
      color: $green;
      line-height: 1.3;
    }

    p {
      margin-top: 5px;
      font-size: 12.5px;
      line-height: 1.55;
      color: $ink;
    }
  }
}

@include mobile {
  .services {
    padding: 48px 0 56px;
  }

  .services__grid {
    grid-template-columns: 1fr;
    grid-template-rows: none;
    grid-auto-flow: row;
    gap: 26px;
    margin-top: 34px;
  }
}
</style>
